import { Box, Button, FormControl, Grid, InputLabel, makeStyles, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import React, { useState } from "react";
import DatePickerTDSAT from "./components/DatePickerTDSAT";
import { format } from "date-fns";
import { getAllDocuments, getCauseListData, printCauseList, removeCaseFromCauselist } from "./API/TdsatApi";
import CourtNumberInput from "./components/CourtNumberInput";
import fileDownload from "js-file-download";
import { PrintOutlined } from "@material-ui/icons";
import MessageBox from "./components/MessageBox";
import theme from "NewTheme";
import { useSnackbar } from "contexts/SnackbarContext";
import Popup from "reactjs-popup";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import { formatDate } from "utils";
import { RequiredLabel } from "features/loginTdsat/Signup";
import CauseListTypeInput from "./components/CauseListTypeInput";

const useStyles = makeStyles((theme) => ({
  root: {
		padding: '1.5rem',
    width: '100%',
    boxSizing: 'border-box',
	},
  label: {
    color: '#121212',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.3125rem',
    textAlign: 'left',
    marginBottom: '0.2rem',
  },
  button: {
    padding: '0.7rem 2rem',
    borderRadius: '0.75rem',
    fontSize: '1.25rem',
    margin: '2rem',
  },
  buttonPrint: {
    borderRadius: '0.5rem',
    border: '1px solid #AAAFB9',
    background: '#fff',
    padding: '0.5rem 1rem',
  },
  header: {
    padding: '2rem 0 0.5rem 0',
    borderBottom: '1px solid #4B4E56',
    marginBottom: '1.5rem',
    '& p': {
      fontSize: '1.37rem',
      fontFamily: 'Satoshi-Bold',
      color: '#4B4E56',
    },
  },
  head: {
    color: '#242529',
    fontSize: '1.5rem',
    fontFamily: 'Satoshi-Bold',
  },
  tableHead: {
    color: '#242529',
    fontFamily: 'Satoshi-Bold',
  },
  tableContent: {
    color: '#242529',
    fontSize: '0.93rem',
    fontFamily: 'Satoshi-Medium',
  }
}));

export default function CauseListReport() {
  const classes = useStyles();
  const { showSnackbar } = useSnackbar();
  const [ openPopup, setOpenPopup ] = useState(false);
  const [ allRelatedDocuments, setAllRelatedDocuments ] = useState([]);
  const [ documentsLoading, setDocumentsLoading ] = useState(false);
  let counter = 0;

  const handleOpenPopup = (case_number) => {
    setOpenPopup(true);
    setAllRelatedDocuments([]);
    setDocumentsLoading(true);
    getAllDocuments(case_number).then((res)=>{
      setAllRelatedDocuments(res?.data);
      setDocumentsLoading(false);
    })
    .catch((error)=>{
      console.log(error);
      setDocumentsLoading(false);
    })
  }

  const [formData, setFormData] = useState({
    date: null,
    benchNature: '',
    causelist_type: '',
    courtNumber: '',
  });

  const {date, benchNature, courtNumber, causelist_type} = formData;
  const [causeListData, setCauseListData] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }; 

  const handleDateInput = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      'date': value,
    }));
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if(date === null || benchNature === '' || courtNumber === '' || causelist_type === ''){
      alert('Please provide Date, Bench Nature, Type and Court Number.');
      return;
    }
    setCauseListData(null);
    const formatedDate = format(date, 'dd-MM-yyyy')
    getCauseListData(benchNature,formatedDate,courtNumber, causelist_type).then((res)=>{
      setCauseListData(res?.data?.[0]);
    }).catch((error)=>{
      console.log('There is some glitch in getting Cause list data: ', error);
      if(error?.response?.status === 400){
        showSnackbar(error?.response?.data?.error, 'error');
      }
    })
  }

  const handlePrintReport = () => {
    if(date === null || benchNature === '' || courtNumber === ''){
      alert('Please provide Date, Bench Nature and Court Number.');
      return;
    }
    const formatedDate = format(date, 'dd-MM-yyyy');
    printCauseList(benchNature,formatedDate,courtNumber).then((res)=>{
      fileDownload(
        res.data,
        `CauseListReport_${formatedDate}.pdf`
      );
    }).catch((error)=>{
      console.log(error);
    })
  }

  const handleRemoveCaseFromCauselist = (head, hearings, hearingId) => {
    removeCaseFromCauselist(hearingId)
    .then((res)=>{
      if(res?.status === 200 && res?.data?.message === 'Deleted successfully'){
        setCauseListData(prev => {
          const newData = {...prev};
          const filteredHearding = hearings?.filter(hearing => hearing?.hearing_id !== hearingId);
          newData.hearing_data[head] = filteredHearding;
          // console.log(head, hearingId, hearings, causeListData, newData);
          return newData;
        })
      }
    })
  }

  return (
    <Box className={classes.root}>
      <Typography align="center" style={{fontSize:'1.5rem', marginBottom: '48px'}}>
        CAUSE LIST REPORT
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2} style={{backgroundColor:'white', padding:'3rem 6rem', width:'75%', margin: 'auto'}}>
          <Grid item xs={6}>
            <FormControl fullWidth margin="none" variant="outlined">
              <RequiredLabel className={classes.label} label={'Date'} />
              <DatePickerTDSAT
                date={formData.date}
                setDate={handleDateInput}
                isRequired={true}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl required fullWidth margin="none" variant="outlined">
              <RequiredLabel className={classes.label} label={'Bench Nature'}/>
              <Select
                name="benchNature"
                value={formData.benchNature}
                onChange={handleInputChange}
                required
              >
                <MenuItem value='single_bench'>Single Bench</MenuItem>
                <MenuItem value='division_bench'>Division Bench</MenuItem>
                <MenuItem value='full_bench'>Full Bench</MenuItem>
                <MenuItem value= 'registrar'>Registrar</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <CauseListTypeInput
              name="causelist_type"
              value={formData?.causelist_type}
              onChange={handleInputChange}
              isInlineLabel={false}
              required
            />
          </Grid>
          <Grid item xs={6}>
            <CourtNumberInput
              courtNumber={formData.courtNumber}
              onChange={handleInputChange}
              listingDate={formData.date}
              isRequired={true}
            />
          </Grid>
        </Grid>
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          type="submit"
          disabled={(date === null || benchNature === '' || courtNumber === '' || causelist_type === '')}
        >
          Submit
        </Button>
        <Box style={{height:'2rem'}}></Box>
      </form>
      {causeListData && (
        <Box>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs>
              <Typography style={{textAlign:'left', fontSize:'1.25rem', fontFamily:'Satoshi-Bold'}}>
                TELECOM DISPUTES SETTLEMENT & APPELLATE TRIBUNAL
              </Typography>
            </Grid>
            <Grid item>
              <Button
                className={classes.buttonPrint}
                size="small"
                endIcon={<PrintOutlined/>}
                onClick={handlePrintReport}
              >
                Print Report
              </Button>
            </Grid>
          </Grid>
          <Box style={{height:'1rem'}}></Box>
          <MessageBox
            title={`LIST OF BUSINESS AT ${causeListData?.bench?.time || causeListData?.bench?.causelist_header || ''} ON ${causeListData?.formatted_date}.`}
            subTitle={'[NOTE: IN CASE OF ASSISTANCE, PLEASE CONTACT, MR. D.B.CHETRI, PPS (MOBILE NO.9560411677)]'}
          />
          <Box style={{height:'1rem'}}></Box>
          <Box style={{backgroundColor:'white'}}>
            <Box className={classes.header}>
              <Typography>
                COURT NO: {causeListData?.bench?.court_number}
              </Typography>
              <Typography>
                BEFORE
              </Typography>
              {causeListData?.judge_names.map((judge,index)=>{
                return (
                  <Typography key={index} style={{color:`${theme?.palette.primary.main}`, textTransform: 'uppercase'}}>
                    {judge?.name}, {judge?.designation}
                  </Typography>
                )
              })}
            </Box><Grid container spacing={1} style={{padding: '1rem 0', border:'1px solid #E5E5E5'}}>
              <Grid item xs={1} className={classes.tableHead}>
                Sr. No.
              </Grid>
              <Grid item xs={2} className={classes.tableHead}>
                Case No.
              </Grid>
              <Grid item container xs={8}>
                <Grid item xs={4} className={classes.tableHead} style={{textAlign:'left'}}>
                  Cause Title
                </Grid>
                <Grid item xs={4} className={classes.tableHead} style={{textAlign:'left'}}>
                  Advocate(s) Name
                </Grid>
                <Grid item xs={4} className={classes.tableHead} style={{textAlign:'left'}}>
                  Advocate Email ID/Phone number
                </Grid>
              </Grid>
            </Grid>
            {Object.keys(causeListData.hearing_data).map((head,index)=>{
              const hearings = causeListData.hearing_data[head];
              return (
                <Box key={index} style={{padding:'0 4px'}}>
                  <Box style={{padding: '1.5rem 0'}}>
                    <Typography className={classes.head}>
                      {head}
                    </Typography>
                  </Box>
                  {hearings.map((hearing,index)=>{
                    const claimant = hearing?.claimant;
                    const respondent = hearing?.respondent;
                    ++counter;
                    return(
                      <Grid container spacing={1} style={{padding: '1rem 0', border:'1px solid #E5E5E5'}} >
                        <Grid item xs={12} className={classes?.tableContent} style={{textAlign:'left'}}>
                          {hearing?.along_with && (
                            <span>{'ALONG WITH'}</span>
                          )}
                        </Grid>
                        <Grid item xs={1} className={classes.tableContent} >
                          {counter}
                        </Grid>
                        <Grid item xs={2} className={classes.tableContent}>
                          <span style={{color:'blue', cursor:'pointer'}} onClick={() => handleOpenPopup(hearing?.case_number)}>{hearing?.case_number}</span>
                          {hearing?.IN && (
                            <>
                              <br/> <br/>IN<br/>
                              <span style={{color:'blue', cursor:'pointer'}} onClick={() => handleOpenPopup(hearing?.IN?.case_number)}>{hearing?.IN?.case_number}</span>
                            </>
                          )}
                          {hearing?.WITH && (
                            hearing?.WITH?.map(x => {
                              return (
                                <>
                                  <br/><br/>WITH<br/>
                                  <span style={{color:'blue', cursor:'pointer'}} onClick={() => handleOpenPopup(x?.case_number)}>{x?.case_number}</span>
                                </>
                              )
                            })
                          )}
                          {hearing?.remark && (
                            <span><br/><br/>{hearing?.remark}</span>
                          )}
                          {hearing?.time_slot && (
                            <span><br/><br/>{hearing?.time_slot}</span>
                          )}
                        </Grid>
                        <Grid item xs={8} style={{textAlign:'left'}}>
                          <Grid container spacing={1}>
                            <Grid item xs={4} className={classes.tableContent}>
                              {claimant.case_name}
                            </Grid>
                            <Grid item xs={4} className={classes.tableContent}>
                              {claimant.name}
                            </Grid>
                            <Grid item xs={4} className={classes.tableContent}>
                              {claimant.email}<br/>{claimant.phone_number}
                            </Grid>
                          </Grid>
                          <Typography className={classes.tableContent}>VS</Typography>
                          <Grid container spacing={1}>
                            <Grid item xs={4} className={classes.tableContent} >
                              {respondent.case_name}
                            </Grid>
                            <Grid item xs={4} className={classes.tableContent}>
                              {respondent.name}
                            </Grid>
                            <Grid item xs={4} className={classes.tableContent}>
                              {respondent.email}<br/>{respondent.phone_number}
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={1} className={classes.tableContent} >
                          {!hearing?.along_with && (
                            <Button type="text" color="primary" style={{padding:'0.2rem 0.7rem'}} onClick={() => handleRemoveCaseFromCauselist(head, hearings, hearing?.hearing_id)} >
                              Remove
                            </Button>
                          )}
                        </Grid>
                      </Grid>
                    )
                  })}
                </Box>
              )
            })}

          </Box>
        </Box>
      )}

      <Popup
        open={openPopup}
        closeOnDocumentClick
        closeOnEscape
        onClose={() => setOpenPopup(false)}
        position="center center"
        modal
        nested
        contentStyle={{
          background: "white",
          width: "90%",
          maxWidth: '900px',
        }}
        overlayStyle={{ background: "rgba(51, 51, 51, 0.45)" }}
      >
        <Box style={{ padding: "1.5rem" }}>
          <Typography style={{textAlign:'center', fontSize:'2rem', marginBottom:'2rem'}}>Documents</Typography>
          <Grid container spacing={2} style={{padding:'15px'}}>
            <Grid xs={2}>
              <Typography style={{textAlign:'center'}}>S.No.</Typography>
              </Grid>
            <Grid xs={7}>
              <Typography>File Name</Typography>
            </Grid>
            <Grid xs={3}>
              <Typography>Uploaded Date</Typography>
            </Grid>
          </Grid>
          {documentsLoading ? (
            <CircularCenteredLoader/>
          ) : (
            allRelatedDocuments?.length > 0 ? (
              allRelatedDocuments?.map((document, index) => {
                return (
                  <Grid container spacing={2} key={index} style={{padding: '8px 15px'}}>
                    <Grid xs={2}>
                      <Typography style={{textAlign:'center'}}>{index+1}</Typography>
                    </Grid>
                    <Grid xs={7}>
                      <Typography><a style={{color:'blue'}} href={document?.link} target="blank">{document?.name}</a></Typography>
                    </Grid>
                    <Grid xs={3}>
                      <Typography>{formatDate(document?.uploaded_at, 'dd/mm/yyyy')}</Typography>
                    </Grid>
                  </Grid>
                )
              })
            ) : (
              <Typography>No documents found.</Typography>  
            )
          )}
        </Box>
      </Popup>
    </Box>
  )
}